import { CreateBranchDto } from './create-branch.dto';
import { PartialType } from '../../../utils';
export class UpdateBranchDto extends PartialType(CreateBranchDto) {
}
